import { BrandService } from '../services/BrandService';
import useToast from '@/composables/useToast';

export const BrandStoreMixin = {
  data() {
    return {
      brands: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 1,
      itemsPerPage: 10,
      search: '',
      isLoading: false,
      parentEdit: false,
    };
  },

  methods: {
    async fetchBrands(page, searchText) {
      const pageToUse = page || this.currentPage;
      const searchToUse = searchText !== undefined ? searchText : this.search;

      this.isLoading = true;
      try {
        const params = {
          page: pageToUse,
          pageSize: this.itemsPerPage,
          name: searchToUse || '',
        };

        const data = await BrandService.getBrands(params);
        this.brands = data.brands;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
        this.currentPage = data.currentPage;
        this.search = searchToUse;
        this.parentEdit = false;
      } catch (error) {
        console.error('Lỗi khi tải thương hiệu:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    async addNewBrand(item) {
      const data = await BrandService.createBrand(item.name);
      if (data) {
        useToast.success(this, data.message);
        await this.fetchBrands();
      }
    },

    async updateBrand(item) {
      const data = await BrandService.updateBrand(item.id, item.name);
      if (data) {
        useToast.success(this, data.message);
        await this.fetchBrands();
      }
    },

    async deleteBrand(id) {
      const data = await BrandService.deleteBrand(id);
      if (data) {
        useToast.success(this, data.message);
        await this.fetchBrands();
      }
    },
  },
};
